<template>
  <div id="root" class="row">
    <div v-if="evaluationInformationData.length > 0" class="col-12">
      <div
        v-for="(evaluation, index) in evaluationInformationData"
        :id="'row_' + evaluation.studentEvaluationId"
        :key="evaluation.studentEvaluationId"
        class="pt-0"
      >
        <div v-if="showAsDiscussion">
          <EvaluationInformationRow
            :ref="`evaluation-discussion-${evaluation.studentEvaluationId}`"
            :items-eval="evaluation"
            :discussion-statuses="discussionCollections.discussionStatuses"
            :rejection-reasons="discussionCollections.rejectionReasons"
            :is-submitted="!evaluation.editable || disabled || readOnly"
            :show-error="true"
            @remove-rejection="onRemoveRejection(evaluation, $event)"
            @add-rejection="onAddRejection(evaluation, $event)"
            @on-delete="removeEvaluation(evaluation, index)"
            @on-determine-change="onDeterminated($event, evaluation)"
            @on-discussion-status-change="
              onDiscussionStatusChange(evaluation, $event)
            "
            @on-push-comments="onPushComments(evaluation, $event)"
          />
        </div>
        <div v-else class="datarow">
          <callout
            :has-toggle="evaluation.hasIcon"
            :opened="evaluation.hasIcon"
            :controlled="true"
            class="mb-3 mt-1"
            @click:open="collapseEvaluation(evaluation)"
          >
            <div class="row py-2">
              <div class="col-md-10">
                <div class="row pt-2">
                  <div
                    class="col-md-1 col-sm-12 d-flex justify-content-center align-items-center"
                  >
                    <div
                      :class="{
                        disabled: !evaluation.editable || disabled || readOnly,
                      }"
                    >
                      <div class="input-group position-relative cb-move">
                        <input
                          :id="'checkbox_' + evaluation.studentEvaluationId"
                          v-model="evaluation.isSelectedFlag"
                          type="checkbox"
                          class="checkbox option-input"
                          @change="onSelected(evaluation)"
                        />

                        <label
                          :for="'checkbox_' + evaluation.studentEvaluationId"
                          class="checkbox-label"
                        >
                          <span v-if="evaluation.isSelectedFlag != null">
                            <em class="ic-check" />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Tipo de Servicio:
                    </div>
                    <div
                      class="mt-2 type-name disabled"
                      :class="{
                        off:
                          !disabled &&
                          !readOnly &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable,
                      }"
                      @click="collapseEvaluation(evaluation)"
                    >
                      <span
                        :class="{
                          'icon-accordion': evaluation.hasIcon != undefined,
                        }"
                      >
                        {{ evaluation.serviceTypeName }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Servicio:
                    </div>
                    <div
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          !readOnly &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable,
                      }"
                    >
                      <span>{{ evaluation.disciplineTypeName }}</span>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Estatus:
                    </div>
                    <div
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          !readOnly &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable,
                      }"
                    >
                      <span>
                        {{ evaluation.statusName }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Aceptada:
                    </div>
                    <div
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          !readOnly &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable &&
                          !evaluationSaved,
                      }"
                    >
                      <CustomRadioGroup
                        :value="String(evaluation.isApprovedByParentFlag)"
                        :name="`accepted-${evaluation.studentEvaluationId}`"
                        :options="radioButtonsOptions"
                        is-inline
                        class="ml-n3"
                        @input="onAccepted($event, evaluation)"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-3 col-sm-12 text-left"
                    v-if="!isOcupacional(evaluation)"
                  >
                    <div
                      v-if="hasOptionDeterminate"
                      class="font-weight-normal font-14 color-gray--6"
                    >
                      ¿Esta evaluación será utilizada en una determinación de
                      elegibilidad?
                    </div>
                    <div
                      v-if="hasOptionDeterminate"
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          !readOnly &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable &&
                          !evaluationSaved,
                      }"
                    >
                      <CustomRadioGroup
                        class="ml-n3"
                        :value="
                          hasManyOptionsDeterminated
                            ? null
                            : getDetermination(evaluation)
                        "
                        :name="
                          `determinated-${evaluation.studentEvaluationId}-${index}`
                        "
                        :options="radioButtonsOptions"
                        is-inline
                        :is-disabled="
                          evaluation.restrictAdditionalEvaluationSelection ||
                            !evaluation.isApprovedByParentFlag ||
                            !evaluation.editable ||
                            disabled ||
                            readOnly
                        "
                        @input="onDeterminated($event, evaluation)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="col disabled off">
                  <div class="dropdown">
                    <button
                      class="btn btn-dropdown-actions dropdown-toggle pt-1"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Acciones
                    </button>
                    <div class="dropdown-menu pb-0">
                      <a
                        v-if="
                          !disabled &&
                            !readOnly &&
                            ((!evaluation.isSelectedFlag && evaluationSaved) ||
                              !evaluationSaved)
                        "
                        class="drop-item cursor-pointer"
                        @click="removeEvaluation(evaluation, index)"
                      >
                        <em class="fas fa-times-circle text-red pr-1" />
                        <span>Remover Evaluación</span>
                      </a>
                      <a
                        v-if="evaluation.statusName != 'Completada'"
                        class="drop-item cursor-pointer"
                        @click="downloadDocument(evaluation)"
                      >
                        <em class="fas fa-search text-green pr-1" />
                        <span>Ver Documento Adjunto</span>
                      </a>
                      <a v-else class="drop-item cursor-pointer">
                        <em class="fas fa-warning text-green pr-1" />
                        <span>No hay opciones</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </callout>
          <a
            :ref="`ei-collapse-${evaluation.studentEvaluationId}`"
            class="hidden"
            data-toggle="collapse"
            :href="`#ei-collapse-${evaluation.studentEvaluationId}`"
            aria-expanded="false"
            :aria-controls="`ei-collapse-${evaluation.studentEvaluationId}`"
          />
          <div
            :id="`ei-collapse-${evaluation.studentEvaluationId}`"
            :class="{ off: evaluation.isSelectedFlag && evaluation.editable }"
            class="col-12 collapse"
          >
            <RejectEvaluationsModal
              v-if="openModal"
              ref="rejectEvaluationsModalRef"
              :load-reject-types="false"
              :rejectTypeList="rejectTypeList"
              @state="gettingState"
              @rejectEvaluationsSave="onSaveNotAccepted($event, evaluation)"
              @rejectEvaluationsCancel="onCancelNotAccepted(evaluation)"
            />
          </div>
        </div>
      </div>
      <Error
        v-if="errors.length == 0"
        variant="no-border"
        :message="error"
        class="mt-1"
      />
      <div v-else>
        <Error
          v-for="err in errors"
          :key="err"
          variant="no-border"
          :message="err"
          class="mt-1"
        />
      </div>
    </div>
    <div v-else class="col-12 text-center">
      <span class="font-weight-normal">
        Al momento el estudiante no cuenta con evaluaciones disponibles para
        discusi&oacute;n.
      </span>
    </div>

    <div
      v-if="!disabled && !readOnly"
      class="d-flex flex-row-reverse bd-highlight w-100 my-4 mr-3"
    >
      <div class="mx-0 bd-highlight ml-2">
        <ActionButton
          v-if="!showAsDiscussion"
          data-target="#add-previous-evaluations-modal"
          data-toggle="modal"
          data-backdrop="static"
          variant="success"
          i="fas fa-file-plus"
          @click.native.prevent="alertOpenModal"
        >
          A&ntilde;adir
        </ActionButton>
        <ActionButton
          v-else-if="showAsDiscussion"
          type="submit"
          text="Añadir"
          i="fa fa-file-plus pl-2"
          variant="success btn-block"
          class="px-1 actions"
          @click.native.prevent="addEvaluationHandler"
        />
      </div>
      <div class="mx-0 bd-highlight">
        <ActionButton
          v-if="!showAsDiscussion"
          variant="success"
          i="fas fa-file-edit"
          @click.native.prevent="selectedEvaluationsModalOpen"
        >
          Modificar
        </ActionButton>
        <ActionButton
          v-else-if="showAsDiscussion"
          type="submit"
          text="Seleccionar otras evaluaciones"
          i="fa fa-edit pl-2"
          variant="outline-success"
          class="px-2 mr-2 actions"
          @click.native.prevent="openCloseSelectManyEvaluations"
        />
      </div>
    </div>
    <div class="col-12" v-if="showAsDiscussion">
      <select-many-evaluations
        v-if="selectManyEvaluationsOpened"
        ref="selectManySelection"
        server-side
        :selected-evaluations="computedAdded"
        @cancel-select-many="openCloseSelectManyEvaluations"
        @continue-select-many="selectedEvaluationsModalSaveHandler"
      />
    </div>
    <div class="col-12" v-else>
      <AddPreviousEvaluationsModal
        v-if="openModal"
        @state="gettingState"
        @refresh="selectedEvaluationsModalSaveHandler"
      />
      <SelectedEvaluationsModal
        ref="selectedEvaluationsModalRef"
        @selectedEvaluations="selectedEvaluationsModalSaveHandler"
      />
    </div>
  </div>
</template>

<script>
import AddPreviousEvaluationsModal from './AddPreviousEvaluationsModal';
import SelectedEvaluationsModal from './SelectedEvaluationsModal';
import RejectEvaluationsModal from './RejectEvaluationsModal';
import generalService from '@/services/pei/general';
import alertService from '@/mixin/alert.mixin';
import ActionButton from '@/components/common/ActionButton';
import CustomRadioGroup from '@/components/common/CustomRadio';
import Error from '@/components/common/Error.vue';
import Callout from '@/components/common/callout/View';
import EvaluationInformationRow from '@/components/studentEvaluation/components/EvaluationInformationRow.vue';
import SelectManyEvaluations from '@/components/studentEvaluation/components/SelectManyEvaluations.vue';

import DisciplineTypes from '@/utils/constants/disciplineTypes';
import ServiceTypes from '@/utils/constants/service-types';
import { discussionStatuses as DiscussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';
import { evaluationStatusCodes } from '@/utils/constants/evaluation-discussion/evaluationStatusCodes';

export default {
  name: 'EvaluationInformationLayout',
  components: {
    AddPreviousEvaluationsModal,
    SelectedEvaluationsModal,
    RejectEvaluationsModal,
    ActionButton,
    CustomRadioGroup,
    Error,
    Callout,
    EvaluationInformationRow,
    SelectManyEvaluations,
  },
  props: {
    showAsDiscussion: { type: Boolean, default: false },
    showActionsColumn: { type: Boolean, default: true },
    showYearsFilter: { type: Boolean, default: true },
    get: { type: Boolean, default: false },
    getValidation: { type: Boolean, default: false },
    evaluationSaved: { type: Boolean, default: false },
    hasOptionDeterminate: { type: Boolean, default: false },
    canDiscussAgain: { type: Boolean, default: false },
    disabled: { type: Boolean, default: () => false },
    readOnly: { type: Boolean, default: () => false },
    evaluationInformationExternalData: { type: Array, default: () => [] },
    error: { type: String, default: () => null },
    errors: { type: Array, default: () => [] },
    hasManyOptionsDeterminated: { type: Boolean, default: false },
    evaluationServiceType: { type: Number, default: () => 2 },
    isInitialPostRegistry: { type: Boolean, default: () => null },
    addAction: { type: Function, default: null },
    value: {
      type: Array,
      default: () => [],
    },
    discussionCollections: {
      type: Object,
      default: () => ({
        discussionStatuses: [],
        rejectionReasons: [],
        allRejectionReasons: [],
      }),
    },
  },
  data() {
    return {
      openModal: true,
      evaluationInformationData: [],
      selectedRow: null,
      statusClasses: {
        previa: 'badge-erase',
        completada: 'badge-complete',
        confirmada: 'badge-signed',
      },
      selected: false,
      radioButtonsOptions: [
        { label: 'Si', value: 'true' },
        { label: 'No', value: 'false' },
      ],
      statusCanDisccus: [
        'Previa',
        'Confirmada',
        'Realizada por Remedio Provisional',
      ],
      multipleImpedimentId: 9,
      rejectTypeList: [],
      selectManyEvaluationsOpened: false,
    };
  },
  methods: {
    async getRejectEvaluationTypeList() {
      const { data } = await this.$ApiGet(`/api/code/evaluationrejectiontypes`);
      this.rejectTypeList = data ?? [];
    },
    isOcupacional(evaluation) {
      return evaluation.disciplineTypeId === DisciplineTypes.Ocupacional;
    },
    // activo flag para habilitar modal.
    alertOpenModal() {
      if (this.addAction != undefined) {
        this.openModal = false;
        this.addAction();
        return;
      }
      this.openModal = true;
    },
    recoverEditedData() {
      const data = this.$store.getters.registryTriannualEvaluationList;
      if (!data) return;
      this.evaluationInformationData = data.evaluationInformationData;
      this.selected = data.selected;
      this.selectManyEvaluationsOpened = data.selectManyEvaluationsOpened;
    },
    saveEditedData() {
      this.$store.commit('setRegistryTriannualEvaluationList', {
        evaluationInformationData: this.evaluationInformationData,
        selected: this.selected,
        selectManyEvaluationsOpened: this.selectManyEvaluationsOpened,
      });
    },
    addEvaluationHandler() {
      this.saveEditedData();
      this.$emit('go-to-add-student-evaluation');
    },
    openCloseSelectManyEvaluations() {
      this.selectManyEvaluationsOpened = !this.selectManyEvaluationsOpened;
    },
    getDetermination(evaluation) {
      const isFalse = [
        evaluation.isSelectedFlag && this.isAdicional(evaluation),
        !!evaluation.restrictAdditionalEvaluationSelection,
        evaluation.isApprovedByParentFlag == false,
      ].includes(true);

      if (isFalse) return 'false';
      //This is the default initial value
      return evaluation.isDeterminated || this.disabled
        ? evaluation.isDeterminated.toString()
        : null;
    },
    // event handler modal
    gettingState(state) {
      this.openModal = state;
    },
    async getEvaluationInformation(
      evaluationsAddedList = '',
      evaluationsExcludedList = ''
    ) {
      const { data } = await this.$ApiGet(
        '/api/studentevaluation/studentevaluationforeligibility',
        {
          StudentSieID: this.$store.getters['$_student/StudentSie'],
          ComparisonDate: null,
          EvaluationServiceType: this.evaluationServiceType ?? 2, // 2=additionalEvaluation enum type
          ExcludedEvaluations: evaluationsExcludedList,
          SelectedEvaluations: evaluationsAddedList,
          evaluationDateId: this.$route.params.evaluationDateId,
          IsInitialPostRegistry: this.isInitialPostRegistry,
          isDisabled: this.disabled,
          excludedStatusIds: `${evaluationStatusCodes.excluded}`,
        }
      ).catch((e) => {
        this.response = e;
        return { data: null };
      });
      if (!data) return;
      const excludesdIds =
        evaluationsExcludedList?.split(', ')?.map((x) => parseInt(x)) ?? [];

      const dataList = this.disabled ? this.value : data;

      dataList.forEach((e) => {
        e.editable =
          e.statusId == -1 && e.isApprovedByParentFlag == null ? true : false;

        e.editable = this.canDiscussAgain
          ? this.statusCanDisccus.includes(e.statusName)
          : true;
        e.isSelectedFlag = e.isDeterminated = e.isImpedimentEvaluationFlag;

        e.isSelectedFlag = e.isApprovedByParentFlag != null;
      });

      const results = [...dataList, ...this.evaluationInformationExternalData];

      const uniqArray = this.$deleteArrayDuplicates(
        results,
        'studentEvaluationId'
      );

      this.evaluationInformationData = (uniqArray ?? [])
        .filter((x) => !excludesdIds.includes(x.studentEvaluationId))
        .map((x) => ({
          ...x,
          rejectionReasons: x.rejectionReasons ?? [],
          isImpedimentEvaluationFlag: x.isImpedimentEvaluationFlag ?? null,
          isDeterminated: x.isDeterminated ?? null,
          discussionStatusId: x.discussionStatusId ?? null,
          isSelectedFlag: this.showAsDiscussion
            ? true
            : x.isSelectedFlag ?? false,
        }));

      const selectedEvaluationsIds = this.evaluationInformationData.map(
        (e) => e.studentEvaluationId
      );
      if (this.showAsDiscussion) {
      } else if (this.$refs.selectedEvaluationsModalRef) {
        this.$refs.selectedEvaluationsModalRef.evaluationsAddedList = selectedEvaluationsIds.join(
          ', '
        );
      }
    },
    getStatusClass(status) {
      let statusClass = '';
      switch (status) {
        case 'Previa':
          statusClass = 'badge-erase';
          break;
        case 'Completada':
          statusClass = 'badge-complete';
          break;
        case 'Confirmada':
          statusClass = 'badge-signed';
          break;
        case 'Realizada por Remedio Provisional':
          statusClass = 'badge-pending-funds';
          break;
      }

      return statusClass;
    },
    onRemoveRejection(evaluation, selectedReason) {
      const reason = this.discussionCollections.rejectionReasons.find(
        (x) => x.id == selectedReason.id
      );
      reason.comment = selectedReason.comment;

      evaluation.rejectionReasons.push(reason);

      const filteredList = this.discussionCollections.rejectionReasons.filter(
        (x) => x.id !== selectedReason.id
      );
      this.discussionCollections.rejectionReasons = filteredList;
    },
    onAddRejection(evaluation, id) {
      const reason = this.discussionCollections.allRejectionReasons.find(
        (x) => x.id == id
      );

      this.discussionCollections.rejectionReasons.push(reason);

      this.discussionCollections.rejectionReasons = this.discussionCollections.rejectionReasons.sort(
        (a, b) => a.id - b.id
      );

      const filteredList = evaluation.rejectionReasons.filter(
        (x) => x.id !== id
      );

      evaluation.rejectionReasons = filteredList;
    },
    onDiscussionStatusChange(evaluation, discussionStatus) {
      if (this.isAdicional(evaluation)) {
        evaluation.isDeterminated = false;
        this.$refs[
          `evaluation-discussion-${evaluation.studentEvaluationId}`
        ][0]?.setDeterminationValue(false);
      }
      evaluation.isApprovedByParentFlag = [
        DiscussionStatuses.accepted,
        DiscussionStatuses.partialAccepted,
      ].includes(discussionStatus?.id);
      evaluation.statusId = discussionStatus?.id;
      evaluation.discussionStatusId = discussionStatus?.id;
      evaluation.rejectionById = null;
      evaluation.rejectionComment = null;
      this.sendDataToParent();
      this.$forceUpdate();
    },
    onPushComments(evaluation, reasons) {
      evaluation.rejectionReasons = reasons;
    },
    async removeEvaluation(evaluation, index) {
      this.evaluationInformationData.splice(index, 1);
      this.nextTick(async () => {
        if (this.showAsDiscussion) {
          if (this.selectManyEvaluationsOpened)
            await this.$refs.selectManySelection.getEvaluations(
              this.computedAdded
            );
        } else if (
          this.$refs.selectedEvaluationsModalRef?.evaluationsAddedList?.includes(
            evaluation.studentEvaluationId
          )
        ) {
          this.$refs.selectedEvaluationsModalRef.evaluationsAddedList = this.$refs.selectedEvaluationsModalRef.evaluationsAddedList
            .split(', ')
            .filter((e) => e != evaluation.studentEvaluationId)
            .join(', ');
          this.$refs.selectedEvaluationsModalRef.evaluationsExcludedList +=
            ', ' + evaluation.studentEvaluationId;
        }
      });
    },
    async downloadDocument(evaluation) {
      if (
        !evaluation.studentEvaluationId ||
        (!evaluation.studentEvaluationsDocumentIds &&
          !evaluation.studentEvaluationsAttachmentIds)
      ) {
        alertService.methods.ShowAlertModal(
          'Atención',
          'La evaluación no contiene documentos adjuntos.',
          null
        );
      }
      let response = await generalService.downloadDocumentByAttachmentId(
        evaluation.studentEvaluationsDocumentIds,
        evaluation.studentEvaluationsAttachmentIds
      );
      if (response) {
        alertService.methods.ShowAlertModal(
          'Atención',
          'La evaluación no contiene documentos adjuntos.',
          null
        );
      }
    },
    selectedEvaluationsModalOpen() {
      this.$refs.selectedEvaluationsModalRef.show();
    },
    selectedEvaluationsModalSaveHandler(
      evaluationsAddedList,
      evaluationsExcludedList
    ) {
      const addeds = Array.isArray(evaluationsAddedList)
        ? evaluationsAddedList.map((x) => x.value).join(', ')
        : evaluationsAddedList;

      const excludeds = Array.isArray(evaluationsExcludedList)
        ? evaluationsExcludedList.map((x) => x.value).join(', ')
        : evaluationsExcludedList;

      if (this.showAsDiscussion) {
        this.selectManyEvaluationsOpened = false;
      }

      this.getEvaluationInformation(addeds, excludeds);
    },
    sendDataToParent() {
      this.$emit('allData', this.evaluationInformationData);

      this.$emit(
        'data',
        this.evaluationInformationData.filter(
          (evaluation) => evaluation.editable && evaluation.isSelectedFlag
        )
      );
    },
    getCollapse(studentEvaluationId) {
      let link = this.$refs[`ei-collapse-${studentEvaluationId}`][0];
      const isOpen = link.getAttribute('aria-expanded') == 'true';
      return { link, isOpen };
    },
    collapseItem({ studentEvaluationId }) {
      let { link } = this.getCollapse(studentEvaluationId);
      link.click();
    },
    collapseEvaluation(evaluation) {
      if (evaluation.hasIcon != undefined) {
        this.collapseItem(evaluation);
      }
    },
    findEvaluation(studentEvaluationId) {
      const row = this.evaluationInformationData.find(
        (e) => e.studentEvaluationId == studentEvaluationId
      );
      return row;
    },
    onSaveNotAccepted(event, evaluation) {
      const row = this.findEvaluation(evaluation.studentEvaluationId);
      row.rejectionById = event.rejectionById;
      row.rejectionComment = event.rejectionComment;
      this.collapseItem(row);
      this.sendDataToParent();
    },
    onCancelNotAccepted(evaluation) {
      this.onAccepted(null, evaluation);
    },
    onAccepted(event, evaluation) {
      let { isOpen, link } = this.getCollapse(evaluation.studentEvaluationId);
      const row = this.findEvaluation(evaluation.studentEvaluationId);
      row.isApprovedByParentFlag = event;

      if (event || event == null) {
        row.rejectionById = null;
        row.rejectionComment = null;
        row.hasIcon = undefined;
        if (isOpen) link.click();
        this.sendDataToParent();
      } else {
        row.hasIcon = true;
        if (!isOpen) link.click();
      }
      this.$forceUpdate();
    },
    onDeterminated(event, evaluation) {
      evaluation.isDeterminated = event;
      evaluation.isImpedimentEvaluationFlag = event;
      this.sendDataToParent();

      // We hide the eligibility panel if is false and there is no evaluation marked with eligible.
      if (
        event ||
        (!event &&
          !this.evaluationInformationData.some(
            (x) => x.isImpedimentEvaluationFlag
          ))
      ) {
        this.$emit('determinated', event); //WHY on the parent is called 'determinated' >\ its not explicit!
      }
    },
    onSelected(event) {
      if (this.isAdicional(event)) {
        event.isDeterminated = false;
      }

      this.sendDataToParent();

      this.$emit('selected', {
        isSelectedFlag: event.isSelectedFlag,
        isDeterminated: event.isDeterminated,
        isImpedimentEvaluationFlag: event.isDeterminated,
      });
    },
    // Validations.
    // Validates that there is an evaluation in an accepted and determined state.
    evaluationAcceptedAndDetermined() {
      if (this.evaluationInformationData) {
        return this.evaluationInformationData.some(
          (x) => x.isApprovedByParentFlag == true && x.isDeterminated == true
        );
      }
      return false;
    },
    // Validates that all evaluations are in an accepted or rejected state.
    allEvaluationsAcceptedOrRejected() {
      if (this.evaluationInformationData) {
        return this.evaluationInformationData.every(
          (x) =>
            x.isApprovedByParentFlag == true ||
            x.isApprovedByParentFlag == false
        );
      }
      return false;
    },
  },
  computed: {
    isAdicional() {
      return (evaluation) =>
        evaluation.serviceTypeId === ServiceTypes.EvaluacionAdicional;
    },
    computedAdded() {
      return this.evaluationInformationData.map((x) => ({
        value: x.studentEvaluationId.toString(),
      }));
    },
    isMultipleimpediment() {
      let impediment = this.$store.getters['$_student/getMipeStudent']
        ? this.$store.getters['$_student/getMipeStudent'].impedimentId
        : null;
      return impediment == this.multipleImpedimentId;
    },
  },
  async mounted() {
    this.$emit('getRef', 'evaluations', this.$refs.observer);
    await this.getRejectEvaluationTypeList();

    if (this.$store.getters.registryTriannualEvaluationList) {
      this.recoverEditedData();
      this.$store.commit('setRegistryTriannualEvaluationList', null);
    } else {
      await this.getEvaluationInformation();
    }
  },
  watch: {
    get: async function(newValue) {
      if (newValue) {
        this.$emit(
          'data',
          this.evaluationInformationData.filter(
            (evaluation) => evaluation.editable && evaluation.isSelectedFlag
          )
        );
      }
    },
    //JA: I understand that this should be handle this way
    evaluationInformationData: {
      deep: true,
      handler(newValue) {
        const data = {
          selectedAllEvaluations: !newValue.some(
            (e) => e.editable && !e.isSelectedFlag
          ),
          evaluations: newValue.filter((e) => e.editable && e.isSelectedFlag),
        };

        this.$emit('on-evaluation-data-changed', data);
      },
    },
    getValidation: async function(newValue) {
      if (newValue) {
        this.$emit('validations', {
          evaluationAcceptedAndDetermined: this.evaluationAcceptedAndDetermined(),
          allEvaluationsAcceptedOrRejected: this.allEvaluationsAcceptedOrRejected(),
        });
      }
    },
  },
};
</script>

<style src="@/assets/css/component/checkbox.css" scoped></style>
<style src="@/assets/css/component/radio-button.css"></style>

<style scoped>
#root >>> td,
#root >>> tr,
#root >>> th {
  text-align: center;
}

#root >>> .vgt-ei tbody {
  background: rgb(225, 228, 224);
  background: linear-gradient(
    180deg,
    rgba(225, 228, 224, 1) 0%,
    rgba(250, 251, 251, 1) 8%
  );
}

.cb-move {
  z-index: 5;
  left: 80%;
  top: 18%;
}

.p-62 {
  padding: 20px 0 !important;
}

.icon-accordion:before {
  font-family: 'Font Awesome 5 Pro';
  opacity: 1;
  position: absolute;
  left: 15%;
  top: 18%;
  font-size: 26px;
}

a[aria-expanded='false'] ~ .type-name:not([disabled]) .icon-accordion:before {
  content: '\f138';
  color: #3f5b60;
}

a[aria-expanded='true'] ~ .type-name:not([disabled]) .icon-accordion:before {
  content: '\f13a';
  font-weight: 900;
  color: #2db782;
}

#root >>> .vgt-ei thead th {
  border-top: none;
  font-weight: bold;
}

#root >>> .vgt-ei td,
#root >>> .vgt-ei td {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}

#root >>> .vgt-ei thead th {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
}

#root >>> .vgt-ei th:first-child {
  border-radius: 10px 0 0 0;
}

#root >>> .vgt-ei th:last-child {
  border-radius: 0 10px 0 0;
}

/*columna estatus*/
#root >>> .vgt-ei .tablebtn {
  padding: 0px 10px;
}

.datarow,
.dataheader {
  text-align: center;
}

.dataheader {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
  border-radius: 10px 10px 0 0;
  padding: 0.75rem;
}

.datarow {
  background-color: rgba(0, 0, 0, 0.025);
}

.datarow >>> .col {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
}
.badge-cancel {
  background: #f4ceb3;
}
.badge-complete {
  background: #f8ea80;
}
.badge-signed {
  background: #a3e5b3;
}
.badge-incomplete {
  background: #f4ceb3;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #dee8b5;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #a7e6dc;
}

.dropdown-menu {
  margin-top: 3px;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: none;
}
.dropdown-toggle::after {
  display: none;
}
.dropleft-toggle::before {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: none;
}
.tiny-chevron {
  font-size: 12px;
  line-height: 20px;
  color: #11291b;
}

/*acciones en tabla */
#root >>> .vgt-eiDropdown .vs__dropdown-toggle {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #2db782;
  border-radius: 4px;
}

#root >>> .vgt-eiDropdown .vs__dropdown-menu {
  margin-top: 5px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

#root >>> .vgt-eiDropdown .vs__search::placeholder {
  border: none !important;
}

#root >>> .vgt-eiDropdown .vs__dropdown-option {
  font: 400 15px/24px Lato;
}

#root >>> .vgt-eiDropdown .vs__dropdown-option:first-child {
  font-weight: bold;
}

#root >>> .vgt-eiDropdown .vs__dropdown-option--highlight {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  color: #11291b;
  font: 400 15px/24px Lato;
}

/* checkbox de edición y class para cells */
input[type='checkbox'] {
  height: 15px;
  width: auto !important;
  margin: auto;
}

.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.disabled.off {
  opacity: 1;
  pointer-events: initial;
}

.panel-simple a,
.panel-simple a:visited,
.panel-simple a:link {
  text-decoration: none;
  color: #ffffff;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-item {
  font: Bold 16px/19px Lato;
}

@media (min-width: 992px) {
  .btn-dropdown-actions {
    width: 4.5rem;
    font-size: 0.7rem;
    margin-right: 0px;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 6rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 7.4375rem;
  }
}

.input-group .circle {
  border: 1px solid #b7b7b7;
}

.input-group .entry-label {
  font-weight: 400;
}
</style>
